export default __webpack_public_path__ + "316339631776fd6f7f753f2fb6304f9d.nrrd";